class MaterialTracker {
    private materials = new Set<any>();

    register(material: any) {
        this.materials.add(material);
    }

    updateIsClipVolumeTool(value: boolean) {
        this.materials.forEach((material: any) => {
            material.setIsClipVolumeTool(value);
            material.needsUpdate = true;
        });
    }

    updateClipBoxFlag(index: number, flags: { mode: number; highlight: boolean; isolate: boolean }) {
        this.materials.forEach((material: any) => {
            material.setClipBoxFlag(index, flags);
            material.needsUpdate = true;
        });
    }

    updateClipPolygonFlag(index: number, flags: { mode: number; highlight: boolean; isolate: boolean }) {
        this.materials.forEach((material: any) => {
            material.setClipPolygonFlag(index, flags);
            material.needsUpdate = true;
        });
    }

    updateHighlightTint(r: number, g: number, b: number) {
        this.materials.forEach((material: any) => {
            material.setHighlightTint(r, g, b);
            material.needsUpdate = true;
        });
    }

    updateStepColours(colours: { r: number; g: number; b: number }[]) {
        this.materials.forEach((material: any) => {
            material.setStepColours(colours);
            material.needsUpdate = true;
        });
    }

    updateDeformationSteps(value: string | number) {
        this.materials.forEach((material: any) => {
            material.setDeformationSteps(value);
            material.needsUpdate = true;
        });
    }
}

// Make it globally available
(window as any).materialTracker = new MaterialTracker();
